import { createAsyncThunk } from "@reduxjs/toolkit";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

// Include helper methods for API calls
import {
  getUsers as getUsersApi,
  getUser as getUserApi,
  updateUser as updateUserApi,
  deleteUser as deleteUserApi,
  changeUserPassword as changePasswordApi,
  changeUserPasswordAdmin as changeUserPasswordAdminApi,
  getUserProfile as getUserProfileApi,
  updateUserProfile as updateUserProfileApi,
  addNewUser as addNewUserApi
} from "../../helpers/fakebackend_helper";

export const getUser = createAsyncThunk("users/getUser", async (queryParams) => {
  try {
    const response = await getUserApi(queryParams);
    return response[0];
  } catch (error) {
    toast.error("Failed to fetch user details", { autoClose: 3000 });
    throw error;
  }
});

// Fetch Users
export const getUsers = createAsyncThunk("users", async () => {
  try {
    const response = await getUsersApi();
    return response;
  } catch (error) {
    toast.error("Failed to fetch users", { autoClose: 3000 });
    throw error;
  }
});

// Add New User
export const addNewUser = createAsyncThunk(
  "users/addNewUser",
  async (user) => {
    try {
      const response = await addNewUserApi(user);
      toast.success("User Added Successfully", { autoClose: 3000 });
      return response;
    } catch (error) {
      toast.error("User Addition Failed", { autoClose: 3000 });
      throw error;
    }
  }
);

// Update User
export const updateUser = createAsyncThunk(
  "users/updateUser",
  async (user) => {
    try {
      const response = await updateUserApi(user);
      toast.success("User Updated Successfully", { autoClose: 3000 });
      return response;
    } catch (error) {
      toast.error("User Update Failed", { autoClose: 3000 });
      throw error;
    }
  }
);

// Delete User
export const deleteUser = createAsyncThunk(
  "users/deleteUser",
  async (userId) => {
    try {
      const response = await deleteUserApi(userId);
      toast.success("User Deleted Successfully", { autoClose: 3000 });
      return { userId, ...response };
    } catch (error) {
      toast.error("User Deletion Failed", { autoClose: 3000 });
      throw error;
    }
  }
);

// Change Password
export const changePassword = createAsyncThunk(
  "users/changePassword",
  async ({ old_password, new_password1, new_password2 }) => {
    try {
      if (new_password1 !== new_password2) {
        toast.error("Passwords do not match", { autoClose: 3000 });
        throw new Error("Passwords do not match");
      }
      const response = await changePasswordApi({ old_password, new_password1, new_password2});
      toast.success("Password Changed Successfully", { autoClose: 3000 });
      return response;
    } catch (error) {
      toast.error("Password Change Failed", { autoClose: 3000 });
      throw error;
    }
  }
);

export const changeUserPassword = createAsyncThunk(
  "users/changeUserPassword",
  async ({ user_id, password, password_verify }) => {
    try {
      const response = await changeUserPasswordAdminApi(user_id, { password, password_verify });
      toast.success("Password Changed Successfully", { autoClose: 3000 });
      return response;
    } catch (error) {
      toast.error("Password Change Failed", { autoClose: 3000 });
      throw error;
    }
  }
);

export const getUserProfile = createAsyncThunk("user/profile", async () => {
  try {
    const response = await getUserProfileApi();
    return response;
  } catch (error) {
    toast.error("Failed to fetch users", { autoClose: 3000 });
    throw error;
  }
});

export const updateUserProfile = createAsyncThunk(
  "user/updateProfile",
  async (user) => {
    try {
      const response = await updateUserProfileApi(user);
      toast.success("User Updated Successfully", { autoClose: 3000 });
      return response;
    } catch (error) {
      toast.error("User Update Failed", { autoClose: 3000 });
      throw error;
    }
  }
);

